export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      action: filter.action[0] ? filter.action : '*',
      status: filter.status[0] ? filter.status : '*',
      updatedByName: filter.updatedByName[0] ? filter.updatedByName : '*',
      _created_at: filter._created_at[0] ? filter._created_at : '*',
      isTestTenant: filter.isTestTenant
        ? filter.isTestTenant === 'True'
          ? true
          : false
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
